export const FIELD_ID = 'assignee';
export const INVITE_PEOPLE_ID = '__INVITE_PEOPLE_ID__';

// TODO: https://jplat.atlassian.net/browse/JIV-14359 use fragments to fetch the default assignee id.
export const AUTOMATIC_ID = 'ari:cloud:identity::user/-1';
export const AUTOMATIC_ACCOUNT_ID = '-1';
